import type { ConsulterEligibiliteSimulationModesLivraison200Response } from '@bytel/pt-ihm-api-portailvente-pev-eligibilite';

import { DeliveryModesType } from '@app-types/product-delivery';

import { SHIPPING_MODES } from '@constants/stock';

export class PevMapper {
    static mapToDeliveryModes(apiData: ConsulterEligibiliteSimulationModesLivraison200Response): DeliveryModesType {
        const deliveryModes = apiData.livraisonsPossibles?.[0]?.livraisons?.[0]?.modesLivraisonPossibles ?? [];

        return deliveryModes.map((mode) => ({
            id: mode.gencode as SHIPPING_MODES,
            estimatedDeliveryDate: mode.dateLivraisonEstimee,
            price: mode.prix,
        }));
    }
}
